/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import React from "react";
import { List, ListItem, ListSubheader, Button, Divider } from "@material-ui/core";
import { ResponseDetails } from "./ResponseDetails";
/**
 * List of all responses from category
 */
export const ResponseList = ({
	responses,
	addResponseHandler,
	removeResponseHandler,
	updateResponseHandler,
	setFormEdited,
	formEdited,
}) => {
	const [responseAutofocus, setResponseAutofocus] = React.useState(false);
	return (
		<div>
			<List
				subheader={
					<ListSubheader disableSticky component="div">
						<div className="d-flex flex-row justify-content-between align-items-center flex-wrap mt-3">
							<span style={{ fontSize: "18px", color: "black" }}>Responses</span>

							<Button
								variant="outlined"
								style={{ backgroundColor: "white" }}
								size="small"
								onClick={() => {
									addResponseHandler();
									setResponseAutofocus(true);
								}}
							>
								ADD RESPONSE
							</Button>
						</div>
					</ListSubheader>
				}
			>
				{responses?.length ? (
					responses.map((response, index) => (
						<React.Fragment key={response.responseId}>
							{index > 0 && <Divider style={{ margin: "10px 0" }} />}
							<ResponseDetails
								response={response}
								removeResponseHandler={() => removeResponseHandler(index)}
								setResponse={(updatedResponse) => {
									const newResponsesList = responses.slice();
									newResponsesList[index] = updatedResponse;
									updateResponseHandler(newResponsesList);
								}}
								setFormEdited={setFormEdited}
								formEdited={formEdited}
								responseAutofocus={responseAutofocus}
							/>
						</React.Fragment>
					))
				) : (
					<ListItem>
						<span className="text-danger font-italic">At least one response is required.</span>
					</ListItem>
				)}
			</List>
		</div>
	);
};
